import React from 'react';

import CheckIcon from '@atlaskit/icon/glyph/check';
import { Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

/**
 * This depicts the checklist of features available in the Standard edition.
 */
export const StandardEditionColumn = ({ standardPrice }: { standardPrice: number }) => {
	const formattedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(standardPrice);

	return (
		<Stack xcss={standardEditionColumnStyles} alignInline="center" space="space.200">
			<Stack alignInline="center">
				<Text weight="semibold" color="color.text.accent.blue.bolder">
					Standard
				</Text>
				<Text weight="semibold" color="color.text.accent.blue.bolder">
					{formattedPrice}
				</Text>
			</Stack>
			<Stack space="space.200">
				{/* Why not put this in a loop? IMO that's actually less readable. */}
				<CheckIcon label="" primaryColor={token('color.icon.accent.green')} />
				<CheckIcon label="" primaryColor={token('color.icon.accent.green')} />
				<CheckIcon label="" primaryColor={token('color.icon.accent.green')} />
				<CheckIcon label="" primaryColor={token('color.icon.accent.green')} />
			</Stack>
		</Stack>
	);
};

const standardEditionColumnStyles = xcss({
	width: '91px',
	height: '333px',
	backgroundColor: 'color.background.input',
	borderRadius: '3px',
	borderWidth: '1px',
	paddingTop: 'space.150',
	boxShadow: 'elevation.shadow.overlay',
	zIndex: 'spotlight', // allows the boxShadow to really pop
});
